import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { ApExpenseModels } from './ApExpenseModels';
import type { APIResponse } from '../../../Shared/shared';

export const addApExpense = createAsyncThunk('ApExpense/addApExpense', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post<APIResponse<any>>('Expense/AddApExpenseHeaders', item);
    if (data?.succeeded) {
      return data;
    } else {
      return rejectWithValue(data);
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
export const updateApExpense = createAsyncThunk('ApExpense/updateApExpense', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post<APIResponse<any>>('Expense/UpdateApExpenseHeaders', item);
    if (data?.succeeded) {
      return data;
    } else {
      return rejectWithValue(data);
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getApExpenseList = createAsyncThunk('ApExpense/getApExpenseList', async (_, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.get<APIResponse<ApExpenseModels[]>>('Expense/GetApExpenseHeadersList');
    if (data?.succeeded) {
      return data?.data;
    } else {
      return rejectWithValue(data.message);
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getApExpenseById = createAsyncThunk(
  'ApExpense/getApExpenseById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<ApExpenseModels>>(`Expense/GetApExpenseHeadersById?id=${id}`);
      return data;
      // if (data?.succeeded) {
      //   return data;
      // } else {
      //   return rejectWithValue(data.message);
      // }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

//  Expense/GetApExpenseHeadersById?id=debb57f3-9fb9-4077-bc29-00e4282fffed

const initialState: {
  ApExpenseList: ApExpenseModels[];
  loading: boolean;
  error: any | null;
  //
  ApExpenseById: ApExpenseModels;
  loadingById: boolean;
  errorById: any | null;
} = {
  ApExpenseList: [],
  loading: false,
  error: null,
  //
  ApExpenseById: {} as ApExpenseModels,
  errorById: null,
  loadingById: false
};

const ApExpenseSlice = createSlice({
  name: 'ApExpense',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getApExpenseList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getApExpenseList.fulfilled, (state, action: PayloadAction<ApExpenseModels[]>) => {
        state.loading = false;
        state.ApExpenseList = action.payload;
      })
      .addCase(getApExpenseList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getApExpenseById.pending, (state, action) => {
    //   state.loadingById = true;
    //   state.errorById = null;
    // })
    // .addCase(getApExpenseById.fulfilled, (state, action: PayloadAction<ApExpenseModels>) => {
    //   state.loadingById = false;
    //   state.ApExpenseById = action.payload;
    // })
    // .addCase(getApExpenseById.rejected, (state, action: PayloadAction<any>) => {
    //   state.loadingById = false;
    //   state.errorById = action.payload;
    // });
  }
});

export default ApExpenseSlice.reducer;
